/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const PAYMENT_CONSTANTS = {
  CASH: 'cash',
  DEBIT_CREDIT: 'debitCredit',
  MANUAL_IMPRINT: 'manualImprint',
  VALID: 'valid',
  CARD_TYPE_DEBIT: 'debit',
  LANGUAGE_PREFERENCE_ENGLISH: 'E',
  APPROVED: 'A',
  INFROMATIONTYPE_DECLINE: 'DECLINED',
  DEBIT_ENTER_PIN: '1',
  DEBIT_INCORRECT_PIN: '15',
  CARD_TYPE_HYBRID: 'hybrid',
  CARD_TYPE_CREDIT: 'credit',
  PIN_ERROR_DEBIT: 'PIN_ERROR_DEBIT',
  INCORRECT_PIN: 'Incorrect Pin',
  POS: 'POS',
  TRACK2: 'Track2',
  ACCOUNT_NUMBER_INDICATOR: 'TemporaryToken',
  MPOS: 'MPOS',
  TRACK2ORDER: '2',
  OPEN: 'Open',
  RETRIEVE_CACHE: 'retrieve_cache',
  ENABLE: 'enable',
};

export const BARCODE_OPTIONS_CONSTANTS = {
  width: 2,
  height: 100,
  displayValue: true,
  fontSize: 15,
  multiplierValue: 90,
  additionValue: 10,
};

export const ORDER_PAYMENT = {
  ORDER_PAYMENT_MODULE: 'PaymentModule',
  CASH_FORM_COMPONENT: 'CashFormComponent',
  PARTIAL_COMPONENT: 'PartialAuthComponent',
  SCANNER_COMPONENT: 'ScannerComponent',
  INSTORE_ORDER_PAYMENT_SERVICE: 'InstoreOrderPaymentService',
  INSTORE_PAYMENT_SERVICE: 'InstorePaymentService',
  INSTORE_ORDER_PAYMENT_COMPONENT: 'InstoreOrderPaymentComponent',
  ONLINE_ORDER_PAYMENT_COMPONENT: 'OnlineOrderPaymentComponent',
  APPROVAL: 'approval',
  CASH: 'Cash',
  CARD: 'Card',
  PART_AUTH: 'PART_AUTH',
  UPDATE: 'UPDATE',
  REMOVE: 'REMOVE',
  REMOVE_SPLITCARD: 'Remove_Splitcard',
  ADD: 'ADD',
  ASTERIK: '****',
  DEBIT: 'debit',
  PAYMENT: 'PAYMENT',
  SOURCE: 'jpay',
  REMOVESPLIT_CARD: 'RemoveSplitcard',
  CREATE: 'create',
  NEW: 'NEW',
  AMOUNT_TYPE: 'USD',
  PAN: 'PAN',
  ADDRESS_FORMAT_TYPE: 'STREET',
  BUTTON_ID: 'button1',
  BUTTON_TYPE: 'submit',
  BUTTON_CLASS: 'btn btn-primary',
  CASH_DRAWER: 'cashdrawer',
  CREDIT: 'CREDIT',
  DISCOVER: 'DISCOVER',
  INSTORE_ORDER_PAYMENT_MODULE: 'InStoreOrderPaymentModule',
  SUBMIT: 'SUBMIT',
  ACTIVATION: 'ACTIVATION',
  HARDGOOD: 'Hardgood',
  MANAGERATEPLAN: 'MANAGERATEPLAN',
  ADDONSERVICES: 'MANAGEADDON',
  FACADESERVERERROR: 'Facade Server Error',
  OPENCASHDRAWERMANUALLY: 'Please open cash drawer manually.',
};
export const PAYMENT_ERROR_CODES = {
  NEGATIVEFILE: '140',
  BANFILE: '141',
  HARDDECLINE: '113',
  HARD_DECLINE_TEXT: 'HD',
  INCORRECT_PIN: '115',
  INCORRECT_PIN_TEXT: 'IP',
};
export const PAYMENT_CONFIRMATION_MODAL = {
  EDIT_PAYMENT_METHOD: 'editPaymentMethod',
  BACK: 'back',
  CART_ROUTE: 'cart',
  SUBMIT: 'submit',
  BUTTON_PRIMARY: 'btn btn-primary',
  FORWARD: 'forward',
  BUTTON_SECONDARY: 'btn btn-secondary',
  ARE_YOU_SURE: 'areYouSure',
};

export const LEAVE_PAGE_MODAL = {
  PAYMENT_METHODS: 'Payment methods will be lost…',
  LEAVE_PAYMENT_PAGE:
    'Leaving the payment page will remove split payment methods. Do you want to continue?',
  CONTINUE: 'Continue',
  CANCEL: 'Cancel',
  SUBMIT: 'submit',
  BUTTON_PRIMARY: 'btn btn-primary',
  BUTTON_SECONDARY: 'btn btn-secondary',
};
export const ONLINE_ORDER_CONSTANTS = {
  CONTROLS: 'controls',
  CVV: 'cvv',
  CARDNUMBER: 'cardNumber',
  EXPIRATIONMONTH: 'expirationMonth',
  EXPIRATIONYEAR: 'expirationYear',
  FULLNAME: 'fullName',
};
